import React from "react";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";
import { getOrderTypeByValue } from "helpers/general";
import moment from 'moment';
import { ROUTE_CLIENT_ORGANIZATIONS_VIEW, ROUTE_CLIENT_USER_VIEW } from "../../../../config/routes";
import { LinkResource } from "../../../../components/shared/LinkResource";
import { TRANSLATED_ORDER_STATUSES, ORGANIZATION_STATUSES, ORDER_STATUSES, USER_STATUSES } from "../../../../config/constants";

function OrderDetailsSection(props) {
  const { item } = props;

  if (!item || !item.id) {
    return (
      <>
        <Row>
          <Col className="col-4 mt-3">
            <FormattedMessage id="messages.no_data" />
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row className="ml-lg-n3 mr-lg-n3 m-0">
        <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
          <table className="table-bordered table-striped table">
            <tbody>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_nr" />
                </th>
                <td>{item.order_number}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_created_at" />
                </th>
                <td>{item.created_at && moment(item.created_at).format('lll')}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_neo_id" />
                </th>
                <td>{item.neo_id}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_neo_invoice_series" />
                </th>
                <td>{item.neo_invoice_series && item.neo_invoice_series.replaceAll(".", " ")}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_neo_invoice_number" />
                </th>
                <td>{item.neo_invoice_number}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_type" />
                </th>
                <td>
                  {getOrderTypeByValue(item.type)}
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.status" />
                </th>
                <td>
                  {TRANSLATED_ORDER_STATUSES[item.status]}
                  {item.status === ORDER_STATUSES.REFUND_ERROR ? (
                    <div className="text-danger mt-1">
                      <FormattedMessage id="messages.order_refund_failed" />
                    </div>
                  ) : null}
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.total" />
                </th>
                <td>
                  {item.total}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
          <table className="table-bordered table-striped table">
            <tbody>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.billing_country" />
                </th>
                <td>{item.billing_country}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.billing_city" />
                </th>
                <td>{item.billing_city}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.billing_address" />
                </th>
                <td>{item.billing_address_line_1} {item.billing_address_line_2 && item.billing_address_line_2.length ? item.billing_address_line_2 : ''}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.billing_phone" />
                </th>
                <td>
                  {item.billing_phone}
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.billing_email" />
                </th>
                <td>
                  {
                    item.user?.id && item.user?.status === USER_STATUSES.ACTIVE ? 
                    <LinkResource
                      displayText={item.user.email}
                      resourceLink={ROUTE_CLIENT_USER_VIEW}
                      resourceParamId={{':userId': item.user.id}}
                    /> :
                    <>{item.billing_email} (<FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />)</>
                  }
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.organization" />
                </th>
                <td>
                  {
                    item.organization?.id && item.organization?.status === ORGANIZATION_STATUSES.CREATED ?
                    <LinkResource
                      displayText={item.organization.name}
                      resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
                      resourceParamId={{':organizationId': item.organization.id}} 
                    /> :
                    <>{item.organization_name} (<FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />)</>
                  }
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.order_cui" />
                </th>
                <td>{item.cui}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="fields.registry_no" />
                </th>
                <td>{item.registry_no}</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}

export { OrderDetailsSection }
